// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3MB3i","icon":"SortAdornment_icon__3FS--","up":"SortAdornment_up__1DdMg","down":"SortAdornment_down__10Fgf","active":"SortAdornment_active__2J59j"};